import React, { useContext } from "react";
import * as tasks from "./August2026Tasks";
import { MaturaReviewContext } from "../../components/MaturaExamRunner/MaturaReviewContext";
import MaturaPdfPreview from "../../components/MaturaPdfPreview";

export const sheet = { id: "cke-p-2026-sierpien", title: "Matura poprawkowa — sierpień 2026",
  subtitle: "Poziom podstawowy · 30 zadań · 34 punktowane części · 50 punktów",
  sourceLabel: "CKE · Formuła 2023 · sierpień 2026", taskCount: 30, maxPoints: 50, sessionType: "resit" };
export const classification = tasks.classification;
export const getVariantCounts = tasks.getVariantCounts;
const group = n => n.split(".")[0];
export function generateTaskVariant(number, variant = "random", options = {}) {
  number = String(number);
  const siblings = tasks.taskNumbers.filter(n => group(n) === group(number));
  if (siblings.length > 1 && !options.single) {
    const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
    const linkedTasks = siblings.map(n => generateTaskVariant(n, variant, { ...options, seed, single: true }));
    return { ...linkedTasks.find(row => row.meta.taskNo === number), linkedTasks };
  }
  const task = tasks.generateTask(number, { ...options, variant });
  const part = number.split(".")[1];
  return { index: tasks.taskNumbers.indexOf(number), task: { ...task, displayBaseNumber: Number(group(number)),
    ...(part ? { maturaGroupId: group(number), maturaGroupPart: Number(part) } : {}) },
    meta: { ...classification.find(row => row.taskNo === number), quizTypeKey: task.type,
      quizKind: ["5", "9", "10", "11", "12", "15", "19", "29", "30"].includes(number) ? "open" : "closed", assessmentMode: task.assessmentMode } };
}
export function generatePagedTasks(variant = "original", options = {}) {
  const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
  return tasks.taskNumbers.map(n => generateTaskVariant(n, variant, { ...options, single: true, seed: `${seed}:${group(n)}` }));
}
export function generateTasks(variant, options) { return generatePagedTasks(variant, options).map(row => row.task); }
function SourceLinks({ task }) {
  const review = useContext(MaturaReviewContext);
  if (review.interactive && !review.reviewAllowed) return null;
  return <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginTop: 16 }}>
    <MaturaPdfPreview url={tasks.pdfUrl("arkusz", task.taskNumber)} title={`Arkusz CKE · sierpień 2026 · zadanie ${task.taskNumber}`} label="Oryginał zadania · sierpień 2026" />
    {task.assessmentMode !== "self" && <MaturaPdfPreview url={tasks.pdfUrl("zasady", task.taskNumber)} title={`CKE · sierpień 2026 · zadanie ${task.taskNumber} · kryteria`} label="Kryteria CKE · sierpień 2026" />}
  </div>;
}
export function renderTask(task) { return <>{tasks.renderTask(task)}<SourceLinks task={task} /></>; }
export const renderInput = tasks.renderInput;
export const checkAnswer = tasks.checkAnswer;
export const renderAnswer = tasks.renderAnswer;
export const renderExplanation = tasks.renderExplanation;
export const renderUserAnswer = tasks.renderUserAnswer;
export function getInteractionSupport() { return { renderInput: true, checkAnswer: true, renderUserAnswer: true }; }
